var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Category',{attrs:{"cate-name":"bythem","category-name":"by them賞","category-intro":"多様な悩みに寄り添うWebメディア「by them」が厳選。心の中のモヤモヤがかたちになって、読めば少し、気持ちが軽くなる。そんなメルマガをセレクトしました。"}})}
var staticRenderFns = []

export { render, staticRenderFns }